import { render, staticRenderFns } from "./GiftcardPreview.vue?vue&type=template&id=677eee1e"
import script from "./GiftcardPreview.vue?vue&type=script&lang=js"
export * from "./GiftcardPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports